module.exports = __webpack_public_path__ + "static/media/Quarter_A.291101e8.png";